<template>
    <v-container>
        <v-row class="mt-3" align="center">
            <v-col cols="12">
                <div class="headline-light secondary-color">
                    Perfil {{ currentEntityLabel }}
                </div>
                <div class="display-heavy primary-color">
                    Panel de pacientes
                </div>
            </v-col>
            <v-col cols="12" md="6" lg="4" v-for="(stat,i) in statCards" :key="i">
                <graphics-card
                    :icon="stat.icon"
                    :img="stat.img"
                    :color="stat.color"
                    :title="stat.title"
                    :number="stat.number"
                    :percent="stat.percent"
                />
            </v-col>
            <v-col cols="12">
                <v-row>
                    <v-col cols="6" md="4">
                        <kimsa-combobox
                            label="Filtrar"
                            @change="profile = $event"
                            :value="profile"
                            :items="profiles"
                            outlined dense clearable
                        />
                    </v-col>
                    <v-col cols="6" md="4">
                        <kimsa-text-field
                            @change="search = $event"
                            :value="search"
                            clearable dense solo flat
                            prepend-inner-icon="mdi-magnify"
                            placeholder="Buscar..."
                        />
                    </v-col>
                    <v-col cols="12" md="4" align="right">
                        <v-btn class="normal-btn" color="primary" outlined large @click="downloadExcel"
                               :loading="loadingExcel">
                            Descargar tabla
                        </v-btn>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="12">
                <kimsa-data-table
                    :headers="headers"
                    :items="patientsFilter"
                    :loading="loadingPatients"
                    @action="onAction"
                    :search="search"
                />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import GraphicsCard from "@/components/cards/GraphicsCard";
import KimsaDataTable from "@/components/common/KimsaDataTable";
import KimsaTextField from "@/components/common/inputs/KimsaTextField";
import KimsaCombobox from "@/components/common/inputs/KimsaCombobox";
import httpService from "@/services/httpService";

const XLSX = require('xlsx');
export default {
    name: "List",
    components: {KimsaCombobox, KimsaTextField, KimsaDataTable, GraphicsCard},
    data() {
        return {
            search: '',
            headers: [
                {text: 'Nombre', value: 'name'},
                {text: 'Rut', value: 'rut', type: 'rut'},
                {text: 'Mail', value: 'email'},
                {text: 'Fecha de Nac.', value: 'birthDate'},
                {text: 'N° Ordenes', value: 'orders'},
                {text: 'Última Orden', value: 'lastOrder'},
                {text: '', value: 'actions'},
            ],
            patients: [],
            loadingProfiles: false,
            loadingPatients: false,
            loadingExcel: false,
            profiles: [],
            profile: null,
        }
    },
    computed: {
        patientsFilter(vm = this) {
            if (!vm.profile) return vm.patients
            if(vm.profile.records.length === 0) return vm.patients.filter(pat => pat.records.length === 0)
            return vm.patients.filter(pat => pat.records?.some(record => vm.profile.records.some(re => re.id === record.id)))
        },
        statCards(vm = this) {
            return [
                {
                    title: 'Total Pacientes',
                    number: vm.statsDashboard?.total_patients || 0,
                    color: '#F4F7FE',
                    img: 'bars-green'
                },
                {
                    title: 'Nuevos Pacientes',
                    number: vm.statsDashboard?.new_patients || 0,
                    percent: vm.statsDashboard?.new_patients_percentage || 0,
                    color: '#F4F7FE',
                    icon: 'mdi-new-box'
                },
            ]
        },
    },
    async mounted() {
        const vm = this
        if(vm.currentEntityId) {
            await vm.loadProfiles()
            await vm.loadPatients()
        }
    },
    methods: {
        async loadProfiles() {
            const vm = this
            vm.loadingProfiles = true

            let response = await httpService.get(`laboratory/${vm.currentEntityId}/profiles`)
            // console.log('response loadProfiles',response)
            vm.profiles = response.data.profiles

            vm.loadingProfiles = false
        },
        async loadPatients() {
            const vm = this
            vm.loadingPatients = true
            console.log('vm.currentEntityId',vm.currentEntityId)
            let response = await httpService.get(`laboratory/${vm.currentEntityId}/users`)
            console.log('response loadPatients',response)

            vm.patients = response.data.users.map(patient => {
                let ordersQuantity = patient.orders.length
                let lastOrder = patient.orders[0]?.created_at ?
                    vm.$moment(patient.orders[0].created_at).format('DD-MM-YYYY') :
                    'n/d'
                return {
                    ...patient,
                    orders: ordersQuantity,
                    birthDate: vm.$moment(patient.birth_date).format('DD-MM-YYYY'),
                    registerDate: vm.$moment(patient.created_at).format('DD-MM-YYYY'),
                    lastOrder: lastOrder,
                }
            })

            vm.loadingPatients = false
        },
        onAction(patientId) {
            const vm = this
            vm.$router.push({name: 'admin.patients.details', params: {patientId: patientId}})
        },
        downloadExcel() {
            const vm = this
            if (vm.patients.length === 0) return vm.toast('Sin datos para exportar', 'error')
            vm.loadingExcel = true
            let patients = vm.patients.map(pat => {
                return {
                    ['Nombre']: pat.name,
                    ['Rut']: pat.rut,
                    ['Mail']: pat.email,
                    ['Teléfono']: pat.phone,
                    ['Fecha de Nac.']: pat.birthDate,
                    ['Fecha de Registro']: pat.registerDate,
                    ['N° Ordenes']: pat.orders,
                    ['Última Orden']: pat.lastOrder
                }
            })
            let data = XLSX.utils.json_to_sheet(patients)
            const workbook = XLSX.utils.book_new()
            const filename = 'Pacientes'
            const date = vm.$moment().format('DD-MM-YYYY')
            XLSX.utils.book_append_sheet(workbook, data, filename)
            XLSX.writeFile(workbook, `${filename} - ${date}.xlsx`)
            vm.loadingExcel = false
        },
    },
    watch: {
        async currentEntityId(val) {
            if (val) {
                await this.loadProfiles()
                await this.loadPatients()
            }
        }
    }
}
</script>

<style scoped>

</style>